import { TMeta } from './types';

export const ADMIN_MENU_KEY = 'app.menu.admin';
export const SIGN_OUT_MENU_KEY = 'app.menu.signOut';
export const HYBRID_MENU_KEY = 'app.menu.hybrid';
export const DATE_FORMAT = 'yyyy-MM-dd';
export const DEFAULT_TIME_ZONE = 'Australia/Sydney';
export const DEFAULT_META: TMeta = {
    totalItems: 0,
    itemCount: 0,
    itemsPerPage: 0,
    totalPages: 0,
    currentPage: 0,
};
